module.exports = __webpack_public_path__ + "img/logo1.d85155fe.png";